export const getValidPackages = (product = {}) => {
  if (!Array.isArray(product?.packages)) {
    return []
  }

  return product.packages
    .filter((pkg) => pkg && pkg.unit && pkg.unit !== '-')
    .slice()
    .sort((a, b) => Number(b?.quantity || 0) - Number(a?.quantity || 0))
}

export const getPackageDisplayValue = (pkg) => {
  if (!pkg?.unit) {
    return '-'
  }

  return `${pkg.unit}${Number(pkg.quantity) > 1 ? ` de ${pkg.quantity}` : ''}`
}

export const getPackageColumns = (products = []) => {
  const maxPackageCount = products.reduce(
    (maxCount, product) => Math.max(maxCount, getValidPackages(product).length),
    0
  )

  return Array.from({ length: maxPackageCount }, (_, index) => ({
    index,
    unitNumber: maxPackageCount - index,
    label: `UNIDAD DE VENTA ${maxPackageCount - index}`
  }))
}

export const getAvailablePackages = (products = []) => {
  if (!products.length) {
    return []
  }

  const commonPackageCount = products.reduce((minCount, product) => {
    return Math.min(minCount, getValidPackages(product).length)
  }, Infinity)

  if (!Number.isFinite(commonPackageCount) || commonPackageCount <= 0) {
    return []
  }

  return Array.from({ length: commonPackageCount }, (_, index) => commonPackageCount - index)
}
